
    import I18n from 'i18nObj';
    
      import 'translations/quizzes.quiz_item_group_view';
      import 'translations/_core';
    
    import 'translations/_core_en';

    export default I18n.scoped('quizzes.quiz_item_group_view');
  